import script from "./TgConvWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./TgConvWindow.vue?vue&type=script&lang=ts&setup=true"

import "./TgConvWindow.vue?vue&type=style&index=0&id=682df3c0&lang=css"
import "./TgConvWindow.vue?vue&type=style&index=1&id=682df3c0&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-682df3c0"]])

export default __exports__